import React from "react";
import { classNames } from "../utils";
import CheckBox from "./CheckBox";
import ReactTooltip from "react-tooltip";

interface LabeledCheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  classes?: string;
  name: string;
  label?: string;
  toolTip?: string;
  preserveLabelCasing?: boolean;
  alignCheckTop?: boolean;
  indeterminate?: boolean;
}

const LabeledCheckbox = ({
  classes,
  label,
  toolTip,
  name,
  preserveLabelCasing,
  alignCheckTop,
  indeterminate,
  ...rest
}: LabeledCheckboxProps) => {
  return (
    <div
      className={classNames(
        "flex",
        alignCheckTop ? "align-top" : "items-center",
        classes ?? ""
      )}
    >
      <div
        className={classNames(
          "flex ",
          alignCheckTop ? "align-top" : "items-center"
        )}
      >
        <CheckBox {...rest} name={name} indeterminate={indeterminate} />
      </div>
      <span
        className="flex"
        {...(toolTip !== undefined && {
          "data-tip": `${label}<hr> What we flag: ${toolTip}`,
        })}
      >
        {label &&
          (preserveLabelCasing ? (
            <span className="text-sm ml-2">{label}</span>
          ) : (
            <span className="text-sm ml-2 capitalize">
              {label.toLocaleLowerCase()}
            </span>
          ))}
      </span>
      <ReactTooltip
        className="w-96 p-2"
        border={false}
        backgroundColor="#6B7280"
        delayHide={1000}
        effect="solid"
        html={true}
        place="right"
      />
    </div>
  );
};

export default LabeledCheckbox;
